import { __decorate, __extends, __metadata } from "tslib";
import ValueObject from "./ValueObject";
import NeoModel from './NeoModel';
var ModelFieldInfo = /** @class */ (function (_super) {
    __extends(ModelFieldInfo, _super);
    function ModelFieldInfo(displayName, valueString) {
        var _this = _super.call(this) || this;
        /**
         * Display name for the field.
         */
        _this.displayName = "";
        /**
         * Lookup of the field value
         */
        _this.valueString = "";
        _this.displayName = displayName;
        _this.valueString = valueString;
        return _this;
    }
    /**
     * If the instance is a container of ModelFieldInfo, the instance is returned, otherwise null is returned.
     */
    ModelFieldInfo.asModelFieldInfoContainer = function (instance) {
        if (instance.fieldInfo &&
            instance.setModelFieldInfo) {
            return instance;
        }
        return null;
    };
    ModelFieldInfo = __decorate([
        NeoModel,
        __metadata("design:paramtypes", [String, String])
    ], ModelFieldInfo);
    return ModelFieldInfo;
}(ValueObject));
export { ModelFieldInfo };
